import React from 'react';
import Button from '@atlaskit/button/new';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import type { TaskId } from '../tasks/constants.tsx';
import { messages } from './ShowMeButton.messages.tsx';

export const ShowMeButton = ({
	onClick,
	taskId,
}: {
	onClick: () => void;
	taskId: TaskId;
}): React.ReactNode => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleClick = () => {
		onClick();
		fireUIAnalytics(createAnalyticsEvent({}), 'button clicked', 'showMe', {
			taskId,
		});
	};

	return (
		<Button appearance="discovery" onClick={handleClick}>
			{formatMessage(messages.showMeButton)}
		</Button>
	);
};
